import Node from '../node.js';
import { PARAM_TYPE } from '../connector.js';
import Utils from '../utils.js';

export default class NodeSwitch extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.INTEGER, 'condition', 0, { minValue: 0, maxValue: 10 });
		this.addInput(PARAM_TYPE.ANY, 'input1', null).setIsUserConnector(true);
		this.addInput(PARAM_TYPE.ANY, 'input2', null).setIsUserConnector(true);

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}
	
	getType()
	{
		return 'switch';
	}

	loadFromObjectSubclass()
	{
		// Before loading, we need to delete the two inputs we created for convenience above,
		// since if the user has renamed them, we'll end up preserving them, loading renamed
		// inputs, messing up order, and doing generally bad things(tm).
		this.deleteInput('input1');
		this.deleteInput('input2');
	}
	
	getSelectedInput(inputValues)
	{
		let pInputs = this.getInputs();
		let iInputIndex = Number(inputValues['condition']);
		// +1 because the first input is condition
		return pInputs[iInputIndex + 1];
	}

	computeInputResult(pInput, scene, pInputNames, computedInputResults)
	{
		let bComputeInputResults = false;
		let pSelectedInput = this.getSelectedInput(computedInputResults);
		if(pInput.getName() === 'condition')
			bComputeInputResults = true;
		else if(pSelectedInput && pSelectedInput.getName() === pInput.getName())
			bComputeInputResults = true;
		
		if(bComputeInputResults)
			return super.computeInputResult(pInput, scene, pInputNames, computedInputResults);
		else
			return null;
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		let pInput = this.getSelectedInput(inputValues);
		if(!pInput)
			return null;

		const strName = pInput.getName();
		let pRes = inputValues[strName];
		// Only turn meshes into arrays
		if(!Array.isArray(pRes) && Utils.getIsMeshObject(pRes))
			pRes = [pRes];

		return pRes;
	}
}
